<!-- ================管理端-卡列表====================-->
<template>
    <div class="admin-screen-container">
        <div class="admin-title-container">卡列表</div>
        <div class="admin-btn-container">
            <div class="admin-btn-item" @click="handleBatch">批量添加卡</div>
        </div>
        <div class="admin-search4-100">
            <div class="admin-search25">
                <div class="admin-search25-name">一级代理:</div>
                <div class="admin-search25-item">
                    <el-select clearable @change="supplierChange"  v-model="queryParams.supplierId"
                               placeholder="请选择">
                        <el-option v-for="item in supplierList" :key="item.supplierId" :label="item.supplierName"
                                   :value="item.supplierId" />
                    </el-select>
                </div>
            </div>
            <div class="admin-search25">
                <div class="admin-search25-name">二级代理:</div>
                <div class="admin-search25-item">
                    <el-select clearable @change="pageList(null)"  v-model="queryParams.secondSupplierId" placeholder="请选择">
                        <el-option v-for="item in secondSupplierList" :key="item.supplierId" :label="item.supplierName"
                                   :value="item.supplierId" />
                    </el-select>
                </div>
            </div>
            <div class="admin-search25">
                <div class="admin-search25-name">卡状态:</div>
                <div class="admin-search25-item">
                    <el-select clearable @change="pageList(null)" v-model="queryParams.cardStatus" placeholder="请选择">
                        <el-option v-for="item in statusList" :key="item.value" :label="item.name"
                                   :value="item.value" />
                    </el-select>
                </div>
            </div>
            <div class="admin-search25">
                <div class="admin-search25-name">是否激活:</div>
                <div class="admin-search25-item">
                    <el-select clearable @change="pageList(null)" v-model="queryParams.isActivate" placeholder="请选择">
                        <el-option v-for="item in activeList" :key="item.value" :label="item.name"
                                   :value="item.value" />
                    </el-select>
                </div>
            </div>
        </div>
        <div class="admin-search4-100 mt5">
            <div class="admin-search25">
                <div class="admin-search25-name">卡类型:</div>
                <div class="admin-search25-item">
                    <el-select clearable @change="pageList(null)"
                               v-model="queryParams.cardType" placeholder="请选择">
                        <el-option v-for="item in cardTypeList" :key="item.value" :label="item.name"
                                   :value="item.value" />
                    </el-select>
                </div>
            </div>
            <div class="admin-search25">
                <div class="admin-search25-name">卡年限:</div>
                <div class="admin-search25-item">
                    <el-input-number @change="pageList(null)"
                                     v-model="queryParams.cardYear"
                                     step-strictly step="1"
                                     :min="0"
                                     :max="100" />
                </div>
            </div>
            <div class="admin-search25"></div>
            <div class="admin-search25">
                <div class="admin-search25-item-input">
                    <el-input class="admin-input1" v-model="queryParams.cardNo" placeholder="请输入卡编号" >
                        <template #append>
                            <el-button @click="handleQuery" class="name-search-btn"
                                       type="primary" icon="el-icon-search" />
                        </template>
                    </el-input>
                </div>
            </div>
        </div>
        <!--数据列表-->
        <div class="mt5">
            <el-table v-loading="loading"
                      cell-class-name="admin-table"
                      show-overflow-tooltip
                      height="calc(100vh - 300px)"
                      :data="dataList"
                      class="admin-table"
                      highlight-current-row>
                <el-table-column type="index" align="center" label="序号" width="60" />
                <el-table-column  label="卡编号" width="200"  align="center" prop="cardNo">
                    <template #default="scope">
                        <div :title="scope.row.cardNo" style="color: #377f7f;"
                             class="text-one cursor">
                            {{ scope.row.cardNo }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="100" align="center" label="卡类型" prop="cardType">
                    <template #default="scope">
                        <div type="success" v-if="scope.row.cardType === 1">B卡</div>
                        <div type="success" v-if="scope.row.cardType === 2">C卡</div>
                        <div type="success" v-if="scope.row.cardType === 3">课程卡</div>
                    </template>
                </el-table-column>
                <el-table-column  label="卡年限" width="80"  align="center" prop="cardYear">
                    <template #default="scope">
                        <div :title="scope.row.cardYear" style="color: #377f7f;"
                             class="text-one cursor">
                            {{ scope.row.cardYear }}年
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="100" align="center" label="卡状态" prop="cardStatus">
                    <template #default="scope">
                        <el-tag type="info" v-if="scope.row.cardStatus === 1">库存</el-tag>
                        <el-tag type="warning" v-if="scope.row.cardStatus === 2">转出</el-tag>
                        <el-tag type="danger" v-if="scope.row.cardStatus === 3">过期</el-tag>
                    </template>
                </el-table-column>
                <el-table-column width="200"  label="一级代理" prop="supplierName" align="center" >
                    <template #default="scope">
                        <div :title="scope.row.supplierName" style="color: #377f7f;" class="text-one cursor">
                            {{ scope.row.supplierName }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="200"  label="二级代理" prop="secondSupplierName" align="center" >
                    <template #default="scope">
                        <div :title="scope.row.secondSupplierName" style="color: #377f7f;" class="text-one cursor">
                            {{ scope.row.secondSupplierName }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="100" align="center" label="是否绑定" prop="isActivate">
                    <template #default="scope">
                        <el-tag type="info" v-if="scope.row.isActivate == 0">未绑定</el-tag>
                        <el-tag type="success" v-if="scope.row.isActivate == 1">已绑定</el-tag>
                    </template>
                </el-table-column>
                <el-table-column width="200"  label="绑定机构" prop="orgName" align="center" >
                    <template #default="scope">
                        <div :title="scope.row.orgName" style="color: #377f7f;" class="text-one cursor">
                            {{ scope.row.orgName }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="140" label="生成时间" align="center" prop="createTime">
                    <template #default="scope">
                        <div>{{ timestampToTime(scope.row.createTime) }}</div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!--  分页  -->
        <div>
            <pagination :background="false" :pageSizes="[10, 20, 30]" :total="total"
                        v-model:page.sync="queryParams.pageNum" v-model:limit.sync="queryParams.pageSize" @pagination="pageList" />
        </div>
    </div>

    <el-dialog title="批量添加卡" v-model="isShowBatchCard" width="300px">
        <el-form ref="batchFormRef" :rules="batchFormRules" :model="batchForm"
                 label-width="80px" class="meeting-form">
            <el-row>
                <el-form-item class="pull-right" label="生成数量" prop="cardCount">
                    <el-input-number v-model="batchForm.cardCount" step-strictly step="1"
                                     :min="10" :max="10000" />
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item class="pull-right" label="卡年限" prop="cardYear">
                    <el-input-number v-model="batchForm.cardYear" step-strictly step="1"
                                     :min="1" :max="10" />
                </el-form-item>
            </el-row>
            <el-row style="width: 100%">
                <el-form-item label="卡类型" prop="cardType">
                    <el-select style="width: 140px;" v-model="batchForm.cardType" placeholder="请选择卡类型">
                        <el-option v-for="item in cardTypeList" :key="item.value" :label="item.name"
                                   :value="item.value" />
                    </el-select>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item>
                    <el-button type="primary" @click="submitBatch">确定</el-button>
                    <el-button @click="isShowBatchCard= !isShowBatchCard">取消</el-button>
                </el-form-item>
            </el-row>
        </el-form>
    </el-dialog>
</template>
<script>
import {batchCard,pageCard} from "@/api/admin/card";
import {timestampDate, timestampToTime} from "@/utils/date";
import {listSupplier} from "@/api/admin/supplier";

export default {
    components: {},
    name: "cardIndex",
    data() {
        return {
            timestampToTime,
            timestampDate,
            loading: false,
            isShowBatchCard: false,
            statusList: [
                { name: '库存', value: 1 },
                { name: '转出', value: 2 },
                { name: '过期', value: 3 },
            ],
            activeList: [
                { name: '未激活', value: 0 },
                { name: '已激活', value: 1 },
            ],
            cardTypeList: [
                { name: 'B卡', value: 1 },
                { name: 'C卡', value: 2 },
                { name: '课程卡', value: 3 },
            ],
            /*分页查询卡*/
            queryParams:{
                supplierId:'',
                secondSupplierId:'',
                cardNo:'',
                cardStatus:'',
                isActivate:'',
                cardType:'',
                cardYear:'',
                pageNum: 1,
                pageSize: 10,
            },
            dataList:[],
            total:0,
            /*批量添加卡*/
            batchForm:{
                cardYear:1,
                cardCount:10,
                cardType:null,
            },
            batchFormRules:{
                cardCount: [{ required: true, message: "请输入生成数量", trigger: "blur" },],
                cardYear: [{ required: true, message: "请输入卡年限", trigger: "blur" },],
                cardType: [{ required: true, message: "请选择卡类型", trigger: "blur" },],
            },
            // 查询一级代理
            querySupplierForm:{
                parentId:"",
                supplierLevel:1,
            },
            supplierList:[],
            // 查询二级级代理
            querySecondSupplierForm:{
                parentId:"",
                supplierLevel:2,
            },
            secondSupplierList:[],
        }
    },
    computed: {},
    watch: {},
    created() {
        this.pageList();
        this.queryListSupplier();
    },
    mounted() {},
    methods: {
        /*===========卡数据查询============*/
        handleQuery(){
            this.pageList(null);
        },
        pageList(e){
            this.loading = true
            this.dataList = [];
            if (e) {
                this.queryParams.pageNum = e.page;
                this.queryParams.pageSize = e.limit;
            }
            pageCard(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.total = res.data.data.total;
                    this.dataList = JSON.parse(JSON.stringify(res.data.data.list));
                    this.loading = false;
                }else {
                    this.$message.error("请求出错")
                    this.loading = false;
                }
            })
        },
        supplierChange(){
            this.queryParams.secondSupplierId = "";
            this.querySecondSupplierForm.parentId = this.queryParams.supplierId;
            listSupplier(this.querySecondSupplierForm).then(res => {
                if (res.data.code === 1) {
                    this.secondSupplierList = res.data.data;
                    this.pageList(null);
                }else {
                    this.$message.error("请求出错")
                }
            })

        },
        // 查询一级代理
        queryListSupplier(){
            listSupplier(this.querySupplierForm).then(res => {
                if (res.data.code === 1) {
                    this.supplierList = res.data.data;
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        /*===========卡管理============*/
        handleBatch(){
            this.isShowBatchCard = true;
        },
        submitBatch(){
            this.$refs["batchFormRef"].validate(valid => {
                if (valid) {
                    batchCard(this.batchForm).then(res => {
                        if (res.data.code === 1) {
                            this.pageList(null)
                            this.isShowBatchCard = false;
                        }else {
                            this.$message.error("请求出错")
                        }
                    })
                }
            })
        },

    },
}
</script>
<style scoped>
.admin-select1{
    width: 90px;
}
.admin-select1 /deep/ .el-select__wrapper {
    height: 30px; /* 高度 */
    line-height: 28px;
    min-height: 30px!important;
}
.admin-input1 /deep/ .el-input__wrapper {
    height: 30px; /* 高度 */
    line-height: 28px;
    min-height: 30px!important;
}
.name-search-btn{
    background-color: #377f7f!important;
    color: #fff!important;
}

</style>
